import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { App } from "antd";
import { Error } from "@triare/auth-redux/dist/saga/common";
import { AlertProps } from "antd/es/alert";
import { RootState } from "../../../../../../../store";
import { actions, moduleName } from "../../../../../../../store/auth";
import { getMessageInError } from "../../../../../../../hooks/fetch";

export interface AlertErrorProps extends AlertProps {
  disable?: boolean;
  error: Error | null;
}

/**
 * Reports through the platform's message toast, the same channel the rest of
 * the app uses for a failed request, and clears the error once shown so a stale
 * one cannot surface again. Renders nothing itself — the component stays in
 * place so the form does not have to know where the error goes.
 */
function AlertError({
  error,
  disable = false,
}: AlertErrorProps): React.ReactNode {
  const { message } = App.useApp();
  const dispatch = useDispatch();

  useEffect(() => {
    if (disable === false && error) {
      message.error(getMessageInError(error));
      dispatch({ type: actions.signUpErrorClear.toString() });
    }
  }, [error, disable]);

  return null;
}

export default connect((state: RootState) => ({
  error: state[moduleName].signUp.error,
}))(AlertError);
